import BillingHistoryCard from '@/components/Profile/Billing/BillingHistoryCard';
import { usePaymentHistory } from '@/Utils/stripeHooks/usePaymentHistory';
import useMediaQuery from '@/Utils/useMediaQuery';
import React from 'react';

const BillingHistory = () => {
  const { data: histories = [], isLoading: historyLoading } =
    usePaymentHistory();

  const isMobile = useMediaQuery('(max-width: 639px)');

  return (
    <div className='pb-20'>
      <h3 className='form-title mt-16 pb-5'>Billing History</h3>
      {historyLoading && <p>Loading billing history...</p>}
      {histories?.length > 0 && !isMobile && (
        <div className='grid grid-cols-resp-histiry gap-4  border-0 border-b border-customBorder border-solid px-10'>
          <p className='font-bold py-5 min-w-36'>Date</p>
          <p className='font-bold py-5 min-w-36'>Status</p>
          <p className='font-bold py-5'>Description</p>
          <p className='font-bold py-5 justify-self-end'>Amount</p>
        </div>
      )}
      {histories?.length > 0
        ? histories.map((history) => (
            <BillingHistoryCard history={history} key={history.id} />
          ))
        : !historyLoading && <p>History is empty</p>}
    </div>
  );
};
export default BillingHistory;
